import dfBrid from '@df-fe/df_hybrid';
import Cookies from 'js-cookie';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';

/**
 * 判断是否是百福德环境或者是maxapp
 */
export function BFD_checkApp() {
  return window.navigator.userAgent.indexOf('BFD-APP') > -1||window.navigator.userAgent.indexOf('MAX-APP') > -1;
}
/**
 * 加载js依赖文件
 */
export function loadFUNJS() {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = '//static.dongfangfuli.com/info/bridge/1.0/prd/app_bridge.min.js';
  document.head.appendChild(script);
  console.log('loadFUNJS11');
}
var timeFun;
/**
 * 跳转至app页面
 * @param {*} pathKey 原生页面key
 *  'city'        //城市选择页
    'user'        //个人中心页
    'userdetail'  //个人详情
    'balance'     //账户余额
    'setting'     //设置页
    'about'       //关于
    'feedback'    //意见反馈
 */
export function BFD_goToAppPage(pathKey) {
  try {
    if (timeFun) {
      clearTimeout(timeFun);
    }
    timeFun = setTimeout(() => {
      const params = {
        pageName: pathKey,
        pageData: ''
      };
      console.log('跳转原生', dfBrid);
      dfBrid.DFWUtils.appShowPage(params, function (respData) {
        var infoStr = JSON.stringify(respData);
        console.log('appShowPage', infoStr);
      });
    }, 200);
  } catch (e) {
    console.log('跳转原生异常', e);
    return false;
  }
  return true;
}
export function BFD_LoginOut() {
  try {
    const params = {
      type: 'tokenTimeout'
    };
    console.log('跳转登陆页', dfBrid);
    dfBrid.DFWUtils.appRelogin(params, function (respData) {
      var infoStr = JSON.stringify(respData);
      console.log('appRelogin', infoStr);
    });
  } catch (e) {
    console.log('跳转登陆页', e);
    return false;
  }
  return true;
}
export function BFD_appBackToStorehome() {
  try {
    if (timeFun) {
      clearTimeout(timeFun);
    }
    timeFun = setTimeout(() => {
      dfBrid.DFWApp.appBackToStorehome();
    }, 200);
  } catch (e) {
    console.log('跳转原生异常', e);
    return false;
  }
  return true;
}
export function BFD_changeAppAddress(city, cityId) {
  console.log(`city${city},cityId${cityId}`);
  try {
    const params = {
      city: city, //城市名     必填
      cityId: cityId //城市id    必填
    };
    dfBrid.DFWCity.appSwitchCityInfo(params, function (respData) {
      var infoStr = JSON.stringify(respData);
      console.log('appRelogin', infoStr);
    });
  } catch (e) {
    console.log('更改原生地址异常', e);
    return false;
  }
  return true;
}
export function BFD_appGetCityInfo(cb?: Function) {
  try {
    dfBrid.DFWCity.appGetCityInfo(function (respData) {
      console.log('appRelogin', respData);
      console.log('bridge', respData);
      const add = Cookies.get('address');
      // if (!add) {
      let cookieCity = {};
      if (respData.data.address) {
        cookieCity = respData.data.address;
      } else {
        cookieCity = respData.data;
      }
      Cookies.set('address', cookieCity, { expires: 365 });
      // const localAddress = JSON.parse(getCatchAddress()) || null;
      DFWebUtilsTools.setCatchAddress(
        respData.data.address.provinceId,
        respData.data.address.provinceName,
        respData.data.address.provinceName,
        respData.data.address.cityId,
        respData.data.address.cityName,
        respData.data.address.cityName,
        respData.data.address.regionId,
        respData.data.address.regionName,
        respData.data.address.regionName,
        respData.data.address.streetId,
        respData.data.address.streetName,
        respData.data.address.streetName,
        respData.data.address?.id ? respData.data.address?.id : '',
        null,
      );
      // }
      cb && cb();
      return cookieCity;
    });
  } catch (e) {
    console.log('更改原生地址异常', e);
    return {};
  }
}
export function BFD_appGetGpsLoc(callBack) {
  try {
    console.log('appLocation调用app');
    dfBrid.DFWLocation.appGetGpsLoc(function (respData) {
      console.log('appLocation回调', respData);
      let location: any = null;
      if (respData.data && respData.data.longitude && respData.data.latitude) {
        location =
        {
          lng: respData.data.longitude,
          lat: respData.data.latitude
        };
      }
      callBack && callBack(location);
      return location;
    });
  } catch (e) {
    console.log('获取APP经纬度异常', e);
    callBack && callBack(null);
    return {};
  }
}
